import React, { useState } from 'react'
import styles from "./articleFilter.module.css"
import { MarkupLayout } from "../../ui/markupLayout/MarkupLayout"
import { ProductList } from "../ProductList/ProductList"
import { useArticleFilter } from '../../../hooks/useArticleFilter';
import { ArticleFilterOptons } from './articleFilterOptions/ArticleFilterOptons';
import { Button } from '../../ui/button/Button';
import { Modal } from '../../ui/modal/Modal';
import { useSearchParams } from 'react-router';

export function ArticleFilter() {

    const { oemProducts, IntersectElement, isLoading } = useArticleFilter()
    const [isOpen, setIsOpen] = useState(false)
    const [searchParams] = useSearchParams()
    const hasSearch = Boolean(searchParams.get("part_number"));

    return (
        <MarkupLayout>
            <div className={styles.articleFilterSection}>
                <div className={styles.button_wrapper}>
                    <Button variant={"dark-blue"} onClick={() => setIsOpen(!isOpen)} width="w-455">Фильтры</Button>
                    <Modal open={isOpen} onClose={() => setIsOpen(false)}> <ArticleFilterOptons isOpen={isOpen} closeModal={setIsOpen} /> </Modal>

                </div>

                <div className={styles.articleFilterWrapper}>
                    <ArticleFilterOptons />
                </div>
                <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                    <ProductList products={oemProducts} />
                    {!hasSearch && !isLoading && (
                        <div style={{ padding: "20px", textAlign: "center" }}>
                            <p>
                                Введите OEM или REF номер для точного поиска запчастей.
                            </p>
                            <p>  Поиск выполняется по полному совпадению, игнорируя пробелы и дефисы.</p>
                        </div>
                    )}
                    {oemProducts?.length === 0 && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '20px' }}><p>Ничего не найдено</p></div>}
                    <IntersectElement />
                </div>
            </div>
        </MarkupLayout>
    )
}
